import { render, staticRenderFns } from "./teamMembers.vue?vue&type=template&id=50b22c8e&scoped=true"
import script from "./teamMembers.vue?vue&type=script&lang=js"
export * from "./teamMembers.vue?vue&type=script&lang=js"
import style0 from "./teamMembers.vue?vue&type=style&index=0&id=50b22c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b22c8e",
  null
  
)

export default component.exports